import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation UploadCombinedPhotoMutation($input: UploadCombinedPhotoInput!) {
    uploadCombinedPhoto(input: $input) {
      startnumber
    }
  }
`;

function commit(environment, eventId, photo, startnumber, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        eventId,
        photo: 'photo',
        startnumber,
      },
    },
    uploadables: {
      photo: photo,
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.uploadCombinedPhoto.startnumber);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };